export function SearchIcon() {
    return(
        <svg  width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9026 12.1759L16.1735 16.5M13.7117 7.75C13.7117 11.2017 10.9561 14 7.557 14C4.15788 14 1.40234 11.2017 1.40234 7.75C1.40234 4.29822 4.15788 1.5 7.557 1.5C10.9561 1.5 13.7117 4.29822 13.7117 7.75Z" stroke="#161320" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    )
}